import type * as React from "react";

import { cn } from "@/lib/utils";

// Base UI has no standalone Label primitive; a native <label> covers htmlFor
// association, and the disabled/peer styling lives in the classes below.
function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: generic label; consumers associate a control via htmlFor or peer/wrapping
    <label
      className={cn(
        "flex select-none items-center gap-2 font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 peer-[[data-disabled]]:opacity-50 group-data-[disabled]:pointer-events-none group-data-[disabled]:opacity-50",
        className
      )}
      data-slot="label"
      {...props}
    />
  );
}

export { Label };
